import "./PopupCalendarEdit.scss";
import React, { useState } from "react";
import Textbox from "../Textbox/Textbox";
import Button from "../Buttons/Buttons";
import {
  getActiveTaskList,
  postActiveTaskList,
  deleteActiveTaskList,
  editActiveTaskList,
} from "../../utils/apiUtils.mjs";

const PopupCalendarEdit = ({
  userID,
  cancelText,
  confirmText,
  setState,
  initialState,
  selectedDate,
  headerText,
  subHeaderText,
  data,
}) => {
  const [searchProject, setSearchProject] = useState({
    project_name: selectedDate.project_name,
    project_id: selectedDate.project_id,
    task_description: selectedDate.description,
  });
  const [isProjectIDValid, setIsProjectIDValid] = useState(false);
  const [isProjectTaskDescriptionValid, setIsProjectTaskDescriptionValid] =
    useState(false);
  const [showList, setShowList] = useState(true);

  const handleEditProject = (event) => {
    if (searchProject.project_id === "") {
      setIsProjectIDValid(true);
      event.preventDefault();
    }
    if (searchProject.task_description === "") {
      setIsProjectTaskDescriptionValid(true);
      event.preventDefault();
    }
    if (
      searchProject.project_id !== "" &&
      searchProject.task_description !== ""
    ) {
      let taskID = data[1].filter((task) => {
        if (
          task.task_description === selectedDate.description &&
          task.start.slice(0, 10) == selectedDate.date
        ) {
          return task;
        }
      });
      taskID = taskID[0].id;
      editActiveTaskListFunction(
        userID,
        taskID,
        searchProject.project_id,
        selectedDate.date,
        searchProject.task_description
      );
      event.preventDefault();
    }
  };

  const handleDelete = async (taskID, ProjectID) => {
    const token = sessionStorage.getItem("token");
    if (!token) {
      return setState(false);
    }
    try {
      const { data } = await deleteActiveTaskList(token, taskID);
      setState(false);
      return data;
    } catch (error) {}
  };

  const editActiveTaskListFunction = async (
    user_id,
    taskID,
    project_id,
    date,
    task_description
  ) => {
    const token = sessionStorage.getItem("token");

    if (!token) {
      setState(false);
    }

    try {
      // Get the data from the API
      await editActiveTaskList(
        token,
        taskID,
        user_id,
        project_id,
        task_description,
        date
      );
      setState(false);
    } catch (error) {
      console.log(error.response.data.message);
    }
  };

  return (
    <div className="popup">
      <div className="popup__inner">
        <div className="popup__content">
          <h1 className="popup__header">{headerText}</h1>
          <label className="popup__sub-header">
            {`${subHeaderText[0]}: ${selectedDate.date}`}
          </label>
          <form onSubmit={handleEditProject}>
            <div>
              <Textbox
                label={"Find a Project"}
                type={"search"}
                name={"findProjectValue"}
                placeholder={"Enter Project Name"}
                onChange={(e) => {
                  setSearchProject({
                    ...searchProject,
                    project_name: e.target.value,
                    project_id: "",
                  });
                  setIsProjectIDValid(false);
                  setShowList(true);
                }}
                value={searchProject.project_name}
              />
              {isProjectIDValid && (
                <label className="popup__sub-header--modifier">
                  Please select valid project
                </label>
              )}
              {showList && (
                <ul>
                  {data[0]
                    .filter((project) => {
                      if (searchProject.project_name.length === 0) {
                        return;
                      }
                      let temp = 0;
                      for (
                        let i = 0;
                        i < searchProject.project_name.length;
                        i++
                      ) {
                        if (
                          searchProject.project_name[i] ===
                          project.project_name[i]
                        ) {
                          temp++;
                        }
                      }
                      return temp === searchProject.project_name.length;
                    })
                    .map((project) => {
                      return (
                        <li
                          key={project.id}
                          onClick={() => {
                            setSearchProject({
                              ...searchProject,
                              project_name: project.project_name,
                              project_id: project.id,
                            });
                            setShowList(false);
                          }}
                        >
                          {project.project_name}
                        </li>
                      );
                    })}
                </ul>
              )}
              <Textbox
                label={"Task Description"}
                type={"text"}
                name={"descriptionValue"}
                placeholder={"Enter Description"}
                onChange={(e) => {
                  setSearchProject({
                    ...searchProject,
                    task_description: e.target.value,
                  });
                  setIsProjectTaskDescriptionValid(false);
                }}
                value={searchProject.task_description}
              />
              {isProjectTaskDescriptionValid && (
                <label className="popup__sub-header--modifier">
                  Please enter task description
                </label>
              )}
            </div>
            <div className="popup__button-container">
              <Button
                id={""}
                icon={""}
                alt={""}
                value={cancelText}
                onclick={() => {
                  setState(false);
                }}
                type={"button"}
                className={""}
              />
              <Button
                id={""}
                icon={""}
                alt={""}
                value="Delete"
                onclick={() => {
                  let taskID = data[1].filter((task) => {
                    // console.log(task.task_description);
                    // console.log(selectedDate.description);
                    // console.log(task.start.slice(0, 10));
                    // console.log(selectedDate.date);
                    if (
                      task.task_description === selectedDate.description &&
                      task.start.slice(0, 10) == selectedDate.date
                    ) {
                      return task;
                    }
                  });
                  taskID = taskID[0].id;
                  console.log(taskID);
                  handleDelete(taskID, selectedDate.project_id);
                }}
                type={"button"}
                className={""}
              />
              <Button
                id={""}
                icon={""}
                alt={""}
                value={confirmText}
                type={"submit"}
                className={""}
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default PopupCalendarEdit;
